import { render, staticRenderFns } from "./Trabajadores.vue?vue&type=template&id=982c011c&lang=pug&"
import script from "./Trabajadores.vue?vue&type=script&lang=js&"
export * from "./Trabajadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports